/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { EIfapmeSide } from './EIfapmeSide';
import {
    EIfapmeSideFromJSON,
    EIfapmeSideFromJSONTyped,
    EIfapmeSideToJSON,
} from './EIfapmeSide';
import type { Int32NullableListSearch } from './Int32NullableListSearch';
import {
    Int32NullableListSearchFromJSON,
    Int32NullableListSearchFromJSONTyped,
    Int32NullableListSearchToJSON,
} from './Int32NullableListSearch';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';

/**
 * 
 * @export
 * @interface DashboardApprenantsNonInscritsSearch
 */
export interface DashboardApprenantsNonInscritsSearch {
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof DashboardApprenantsNonInscritsSearch
     */
    idpri?: Int32NullableListSearch;
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof DashboardApprenantsNonInscritsSearch
     */
    idari?: Int32NullableListSearch;
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof DashboardApprenantsNonInscritsSearch
     */
    idcentre?: Int32NullableListSearch;
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof DashboardApprenantsNonInscritsSearch
     */
    idmetier?: Int32NullableListSearch;
    /**
     * 
     * @type {Int32NullableListSearch}
     * @memberof DashboardApprenantsNonInscritsSearch
     */
    idstade?: Int32NullableListSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof DashboardApprenantsNonInscritsSearch
     */
    iddegre?: StringListSearch;
    /**
     * 
     * @type {EIfapmeSide}
     * @memberof DashboardApprenantsNonInscritsSearch
     */
    ifapmeSide?: EIfapmeSide;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardApprenantsNonInscritsSearch
     */
    hideMasquees?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardApprenantsNonInscritsSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DashboardApprenantsNonInscritsSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardApprenantsNonInscritsSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardApprenantsNonInscritsSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DashboardApprenantsNonInscritsSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardApprenantsNonInscritsSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DashboardApprenantsNonInscritsSearch interface.
 */
export function instanceOfDashboardApprenantsNonInscritsSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardApprenantsNonInscritsSearchFromJSON(json: any): DashboardApprenantsNonInscritsSearch {
    return DashboardApprenantsNonInscritsSearchFromJSONTyped(json, false);
}

export function DashboardApprenantsNonInscritsSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardApprenantsNonInscritsSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idpri': !exists(json, 'idpri') ? undefined : Int32NullableListSearchFromJSON(json['idpri']),
        'idari': !exists(json, 'idari') ? undefined : Int32NullableListSearchFromJSON(json['idari']),
        'idcentre': !exists(json, 'idcentre') ? undefined : Int32NullableListSearchFromJSON(json['idcentre']),
        'idmetier': !exists(json, 'idmetier') ? undefined : Int32NullableListSearchFromJSON(json['idmetier']),
        'idstade': !exists(json, 'idstade') ? undefined : Int32NullableListSearchFromJSON(json['idstade']),
        'iddegre': !exists(json, 'iddegre') ? undefined : StringListSearchFromJSON(json['iddegre']),
        'ifapmeSide': !exists(json, 'ifapmeSide') ? undefined : EIfapmeSideFromJSON(json['ifapmeSide']),
        'hideMasquees': !exists(json, 'hideMasquees') ? undefined : json['hideMasquees'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DashboardApprenantsNonInscritsSearchToJSON(value?: DashboardApprenantsNonInscritsSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idpri': Int32NullableListSearchToJSON(value.idpri),
        'idari': Int32NullableListSearchToJSON(value.idari),
        'idcentre': Int32NullableListSearchToJSON(value.idcentre),
        'idmetier': Int32NullableListSearchToJSON(value.idmetier),
        'idstade': Int32NullableListSearchToJSON(value.idstade),
        'iddegre': StringListSearchToJSON(value.iddegre),
        'ifapmeSide': EIfapmeSideToJSON(value.ifapmeSide),
        'hideMasquees': value.hideMasquees,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

